import React, { Component } from "react"

class PageSpec extends Component {
  render() {
    return (
      <div className="table">
        <p>Nothing here.</p>
      </div>
    )
  }
}

export default PageSpec



// WEBPACK FOOTER //
// ./src/components/PageSpec.js